var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonHelp = function SvgButtonHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    preserveAspectRatio: "none",
    viewBox: "0 0 34 34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffce41}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header_Buttons",
    "data-name": "Header Buttons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.411.152 6.929 2.894l-1.828 8.224 5.483.914 2.741-5.483 3.656-.914 2.74 3.656-1.827 3.655-2.741 3.654v5.483l4.568.248 1.828-3.903 3.655-3.655 1.827-3.655-.913-8.224L20.635.152zM15.153 25.738l-1.828 4.113 3.655 4.111 5.483-1.251v-6.059l-3.656-1.827z",
    className: "cls-1"
  }))));
};
export default SvgButtonHelp;